module.exports = __webpack_public_path__ + "static/office_2-4ca9569218d438affa0c73f71e31d32b.png";